import { cn } from "@/lib/utils.js";

/**
 * Common loading components to reduce repeated code
 */
export const LoadingCard = ({ className, children, ...props }) => (
  <div
    className={cn(
      "bg-card border border-border rounded-lg shadow-sm",
      className
    )}
    {...props}>
    {children}
  </div>
);

export const LoadingSkeleton = ({ className, ...props }) => (
  <div
    className={cn("animate-pulse bg-muted rounded", className)}
    {...props}
  />
);

export const LoadingSpinner = ({ className, ...props }) => (
  <div
    className={cn(
      "animate-spin rounded-full h-6 w-6 border-b-2 border-foreground",
      className
    )}
    {...props}
  />
);

export const LoadingText = ({ className, ...props }) => (
  <div
    className={cn("animate-pulse h-6 bg-muted rounded w-64", className)}
    {...props}
  />
);

export const LoadingGrid = ({ count = 8, className, ...props }) => (
  <div className={cn("animate-pulse space-y-4", className)} {...props}>
    {[...Array(count)].map((_, i) => (
      <div key={i} className='h-16 bg-muted rounded' />
    ))}
  </div>
);
